export default {
  //
  setTreeData(state, data) {
    state.treeData = data;
  },

  setTableData(state, data) {
    state.tableData = data;
  }
};
